import type { FC, ReactNode } from 'react'

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' fill='none' aria-hidden='true' focusable='false' className={className}>
            <circle cx='16.5' cy='16' r='13.5' stroke='currentColor' strokeWidth='2' />
            <circle cx='12' cy='16' r='9' stroke='currentColor' strokeWidth='2' />
            <circle cx='7.5' cy='16' r='4.5' fill='currentColor' />
        </svg>
    )
}
